import FormField from "./FormField";

const RadioGroup = ({
  label,
  name,
  options,
  selectedValue,
  onChange,
  description,
  required,
}) => (
  <FormField label={label} required={required} description={description}>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 pt-2">
      {options.map((option) => (
        <label key={option.value} className="flex items-center space-x-2">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={onChange}
            className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600 focus:ring-offset-2 focus:ring-2"
          />
          <span className="text-sm text-gray-700">{option.label}</span>
        </label>
      ))}
    </div>
  </FormField>
);

export default RadioGroup;
